import React, { useState, useEffect } from "react";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { NavLink, Switch } from "../NavbarStyles";
import { Container, Row, Inner, Title } from "./Styles";

import { AOO_API_HOST } from "../../../env";
import SearchBar from "../Components/SearchBar";
import Machine from "./OpenLogMachine";
import Routes from "../../Data/Routes";

const Log: React.FC = () => {
  const navigate = useNavigate();
  const [searchResults, setSearchResults] = useState([]);
  const [originalSearchResults, setOriginalSearchResults] = useState([]);
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const handleClick = (e, machine) => {
    navigate(Routes.MainLogOptions, {
      state: { machine: machine },
    });
  };

  // Every machine is fetched once and the pinned/unpinned split is done on the client,
  // so the toggle does not cost a round trip.
  useEffect(() => {
    const fetchData = async (url) => {
      try {
        const response = await axios.get(AOO_API_HOST + url);
        const data = response.data;
        setSearchResults(data);
        setOriginalSearchResults(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData("/aoo-api/ProductionsLog/PinnedMachines");
  }, []);

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsChecked(checked);
    if (checked) {
      setSearchResults(
        originalSearchResults.filter((item) => item.isPinned === true)
      );
    } else {
      setSearchResults(originalSearchResults);
    }
  };

  return (
    <>
      <NavLink
        onClick={() => {
          navigate(Routes.Main);
        }}
        style={{ marginRight: 30 }}
      >
        Back to menu
      </NavLink>
      <Title>Machine Log Entry</Title>
      <Title>
        <SearchBar
          machines={originalSearchResults}
          setSearchResults={setSearchResults}
        />
      </Title>
      <Container>
        <Inner>
          <Title>
            Filter pinned machines
            <Switch style={{ marginBottom: "10px" }} key={"switch1"}>
              <input
                type="checkbox"
                id="switch"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="switch">Toggle</label>
            </Switch>
          </Title>
          <Row>
            {searchResults.map((machine, index) => {
              const className = machine.IsUrgent
                ? `${machine.EventState}-U machine`
                : `${machine.EventState} machine`;

              return (
                <Machine
                  handleClick={handleClick}
                  machine={machine}
                  key={index}
                  value={machine.MachineId}
                  className={`${className} act`}
                />
              );
            })}
          </Row>
        </Inner>
      </Container>
    </>
  );
};

export default Log;
